import React, { ReactElement, FC, cloneElement, useMemo } from "react";
import { Transition } from "react-transition-group";

import { TransitionProps } from "../types";

interface IResizeTransition extends TransitionProps {
  children: ReactElement;
}

export const ResizeTransition: FC<IResizeTransition> = ({
  in: inProp = false,
  onEnter,
  onExited,
  children,
  style,
  timeout = 200,
}) => {
  const defaultStyle = useMemo(() => {
    return {
      transitionProperty: "width, height",
      transitionDuration: `${timeout}ms`,
      transitionTimingFunction: "ease",
    };
  }, [timeout]);

  return (
    <Transition
      appear
      in={inProp}
      timeout={timeout}
      onEnter={onEnter}
      onExited={onExited}
    >
      {(state): ReactElement => {
        return cloneElement(children, {
          style: {
            visibility: state === "exited" && !inProp ? "hidden" : undefined,
            ...defaultStyle,
            ...style,
            ...children.props.style,
          },
        });
      }}
    </Transition>
  );
};

ResizeTransition.displayName = "ResizeTransition";
